<aside class="flex flex-col h-full bg-secondary-700 text-surface-50 w-64 border-r border-surface-800">
    <!-- Header / User Profile -->
    <div class="p-4 gap-4 flex flex-col">
        <h5 class="text-surface-50 mb-2">系統選單</h5>

        <!-- User Card -->
        <div class="rounded-xl border border-primary-500/30 bg-primary-500/10 p-4 flex items-center gap-3">
            <p-avatar icon="pi pi-user" shape="circle" size="normal" class="shrink-0"
                style="background-color: var(--p-primary-500); color: #FFFFFF"></p-avatar>
            <div class="flex-1 min-w-0">
                <div class="text-xs text-primary-400 truncate w-full" title="登入人員">{{
                    userService.currentUser()?.role?.roleName || '載入中...' }}</div>
                <div class="font-bold text-surface-0 truncate w-full" title="admin">{{ userService.currentUser()?.name
                    || '請稍候' }}</div>
            </div>
        </div>
    </div>


    <!-- Scrollable Menu -->
    <div class="flex-1 min-h-0 w-full">
        <p-scrollPanel styleClass="w-full h-full">
            <p-panelMenu [model]="items" styleClass="w-full border-none dark-theme-menu" [multiple]="false"></p-panelMenu>
        </p-scrollPanel>
    </div>

    <!-- Footer -->
    <div class="mt-auto p-4 border-t border-surface-800 flex flex-col gap-6">
        <div class="w-full">
            <p-button severity="secondary" [text]="true" styleClass="w-full !justify-start pl-2 logout-btn"
                (onClick)="logout()">
                <i class="pi pi-sign-out mr-2"></i>
                <span class="font-bold">登出</span>
            </p-button>
        </div>

        <div class="text-xs text-surface-500 w-full">
            <div class="mb-1">系統版本</div>
            <div class="font-bold text-surface-300">v{{ appVersion }}</div>
            <div class="mt-1">&copy; 2026 永彰智慧辦公室系統</div>
        </div>
    </div>
</aside>